import * as Yup from 'yup';

const RegisterIdentitySchema = Yup.object().shape({
    nric: Yup.string()
        // .matches(/^[STFGstfg]\d{7}[A-z]$/, 'Nric format is invalid.')
        .required('NRIC / FIN / Passport No is required'),
});

export default RegisterIdentitySchema;